import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import TableGeneric from "../../compartidos/abms/TableGeneric";
import EditButtonAbm from "../../compartidos/abms/EditButtonAbm";
import DeleteButtonAbm from "../../compartidos/abms/DeleteButtonAbm";
import { FetchCategoriasReclamos } from "../../../actions/reclamos/reclamosActions";
import AddButtonAbm from "../../compartidos/abms/AddButtonAbm";
import FormCategoriasReclamos from "./Forms/FormCategoriasReclamos";
import { eliminarCategoriaReclamoAction } from "../../../actions/reclamos/abmReclamosActions";

export const AbmCategoriasReclamos = () => {
  const { listaCategoriasReclamos } = useSelector((state) => state.reclamos);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(FetchCategoriasReclamos());
  }, [dispatch]);

  const handleDelete = (id) => {
    dispatch(eliminarCategoriaReclamoAction(id));
  };

  return (
    <>
      <AddButtonAbm
        permiso={null}
        title="+ Agregar Nueva Categoría"
        form={FormCategoriasReclamos}
        style={{ float: "right", marginRight: "10px" }}
      />
      <TableGeneric
        rowPerPage={8}
        data={listaCategoriasReclamos}
        columns={[
          {
            label: "",
            customBody: (item) => (
              <>
                <EditButtonAbm
                  permiso={null}
                  item={item}
                  form={FormCategoriasReclamos}
                />
                <DeleteButtonAbm
                  permiso={null}
                  handleDelete={() => handleDelete(item.id)}
                  mensajeEliminacion={`¿Estás seguro que deseas eliminar la categoría "${item.descripcion}"?`}
                />
              </>
            ),
          },
          {
            label: "Descripción",
            id: "descripcion",
          },
        ]}
      />
    </>
  );
};
